import {isNullOrUndefined} from "../../../services/Validator";
import GlossaryTermsByLetterList from "../../lists/glossaryScreen/GlossaryTermsByLetterList";

export default function GlossaryTerms({terms, refs, highlight, search}) {
    // Used in GlossaryContent as a shortcut to specific letter related content

    // BUILD
    if (isNullOrUndefined(terms))
        return null
    return (
        <div className="w-full flex flex-col justify-start items-center">
            {Object.keys(terms).map((letter) => (
                <GlossaryTermsByLetterList key={letter}
                                           terms={terms}
                                           letter={letter}
                                           refs={refs}
                                           highlight={highlight}
                                           search={search} />
            ))}
        </div>
    );
}